import { createSelector } from 'reselect';

import type { RootState } from 'reducers/index';

export const getState = (state: RootState) => state.hardwares;

const getUIState = createSelector(getState, state => state.ui);
const getUIDashboard = createSelector(getUIState, ui => ui.dashboard);

export const getFilters = createSelector(getUIDashboard, dashboard => dashboard.filters);
